
import React from 'react';
import ArtistRealDataTable from '@/components/tables/ArtistRealDataTable';
import SponsorRealDataTable from '@/components/tables/SponsorRealDataTable';
import RevellerRealDataTable from '@/components/tables/RevellerRealDataTable';
import OrganizerRealDataTable from '@/components/tables/OrganizerRealDataTable';
import DAOMemberRealDataTable from '@/components/tables/DAOMemberRealDataTable';
import DaoGovernorRealDataTable from '@/components/tables/DaoGovernorRealDataTable';
import ServiceProviderRealDataTable from '@/components/tables/ServiceProviderRealDataTable';
import { UserRole } from '@/types';
import { Button } from '@/components/ui/Button';

interface RosterPageProps {
  onNavigate: (view: string) => void;
  currentUserRole: UserRole;
  currentUserId: string;
}

const RosterPage: React.FC<RosterPageProps> = ({ onNavigate, currentUserRole, currentUserId }) => {

  return (
    <div className="space-y-8 animate-in fade-in">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold text-white mb-1">Roster Management</h1>
        <div className="flex space-x-2">
          <Button onClick={() => onNavigate('roster_analytics')}>View Analytics</Button>
          <Button onClick={() => onNavigate('dashboard')}>Back to Dashboard</Button>
        </div>
      </div>
      <div id="roster-tables" className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-8">
        <div>
          <h2 className="text-2xl font-bold text-white mb-4">Artists</h2>
          <ArtistRealDataTable currentUserRole={currentUserRole} currentUserId={currentUserId} />
        </div>
        <div>
          <h2 className="text-2xl font-bold text-white mb-4">Sponsors</h2>
          <SponsorRealDataTable currentUserRole={currentUserRole} currentUserId={currentUserId} />
        </div>
        <div>
          <h2 className="text-2xl font-bold text-white mb-4">Revellers</h2>
          <RevellerRealDataTable currentUserRole={currentUserRole} currentUserId={currentUserId} />
        </div>
        <div>
          <h2 className="text-2xl font-bold text-white mb-4">Organizers</h2>
          <OrganizerRealDataTable currentUserRole={currentUserRole} currentUserId={currentUserId} />
        </div>
        <div>
          <h2 className="text-2xl font-bold text-white mb-4">DAO Members</h2>
          <DAOMemberRealDataTable currentUserRole={currentUserRole} currentUserId={currentUserId} />
        </div>
        <div>
          <h2 className="text-2xl font-bold text-white mb-4">Service Providers</h2>
          <ServiceProviderRealDataTable currentUserRole={currentUserRole} currentUserId={currentUserId} />
        </div>
        <div>
          <h2 className="text-2xl font-bold text-white mb-4">DAO Governance</h2>
          <DaoGovernorRealDataTable currentUserRole={currentUserRole} currentUserId={currentUserId} />
        </div>
      </div>
    </div>
  );
};

export default RosterPage;
